/* ENGORI — Sterne oben führen zu den Bewertungen unten
   ---------------------------------------------------------------------------
   Über dem Produktnamen steht die Sternebewertung. Wer darauf klickt, erwartet
   die Bewertungen — bislang passierte nichts. Dieses Skript verbindet beides.

   Warum per Skript und nicht als Ankerlink im Template: Das Sprungziel heisst
   auf jeder Seite anders (Shopify haengt die Template-Kennung an die
   Sektions-ID), und die Sterne stecken in einem Shrine-Block, der an mehreren
   Stellen eingebunden ist. Ein fester Anker im Template waere auf der Haelfte
   der Seiten ins Leere gelaufen.

   Gesucht wird deshalb zur Laufzeit: der erste Sterne-Block, der VOR einer
   Bewertungssektion steht. Steht keine Bewertungssektion darunter — etwa auf
   einer Seite ohne Bewertungen — bleibt alles wie es war.
*/
(function () {
  'use strict';

  var ZIELE = '[id*="trustpilot_reviews"], [id*="testimonials"], [id*="reviews"]';

  function einrichten() {
    var sterne = document.querySelector('.trustpilot-stars');
    if (!sterne || sterne.dataset.engAnker) return;

    // Liegt der Block selbst schon in einer Bewertungssektion, waere der Sprung
    // ein Sprung auf sich selbst.
    if (sterne.closest(ZIELE)) return;

    var ziel = null;
    document.querySelectorAll(ZIELE).forEach(function (k) {
      if (ziel) return;
      // compareDocumentPosition: 4 = k folgt im Dokument auf die Sterne
      if (sterne.compareDocumentPosition(k) & Node.DOCUMENT_POSITION_FOLLOWING) ziel = k;
    });
    if (!ziel) return;

    sterne.dataset.engAnker = '1';
    sterne.classList.add('eng-zu-bewertungen');
    sterne.setAttribute('title', 'Zu den Bewertungen');

    function hin(e) {
      e.preventDefault();
      // Der Kopfbereich klebt oben — ohne Abzug verschwindet die Ueberschrift
      // der Zielsektion darunter.
      var kopf = document.querySelector('.header-wrapper, header, .section-header');
      var abzug = kopf ? kopf.getBoundingClientRect().height : 0;
      var y = ziel.getBoundingClientRect().top + window.pageYOffset - abzug - 12;
      window.scrollTo({ top: y, behavior: 'smooth' });
      // 25.09.2026 (BFSG-09): Fokus springt mit, sonst setzt Tab oben fort.
      if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
      ziel.focus({ preventScroll: true });
    }

    /* 25.09.2026 (BFSG-09): Trägt der Block schon einen Link (Einstellung
       scroll_id), wird dieser genutzt. Vorher lag role=button um den Link
       herum (verschachtelte Bedienelemente) und hieß nur „Zu den Bewertungen
       springen“; die sichtbare Bewertung fehlte im Namen. */
    var link = sterne.querySelector('a[href]');
    if (link) {
      link.addEventListener('click', hin);
    } else {
      var sichtbar = (sterne.textContent || '').replace(/\s+/g, ' ').trim();
      sterne.setAttribute('role', 'link');
      sterne.setAttribute('tabindex', '0');
      sterne.setAttribute('aria-label', sichtbar ? sichtbar + ' – zu den Bewertungen' : 'Zu den Bewertungen');
      sterne.addEventListener('click', hin);
      sterne.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') hin(e);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }
  /* Varianten-Wechsel und Slider bauen den Produktbereich neu auf.
     25.09.2026 (CODE-07): nur reagieren, wenn ein Sterne-Block dazukommt,
     nicht bei jeder DOM-Änderung. */
  function bringtSterne(n) {
    if (n.nodeType !== 1) return false;
    return n.matches('.trustpilot-stars') || !!n.querySelector('.trustpilot-stars');
  }
  var warte;
  new MutationObserver(function (aenderungen) {
    for (var i = 0; i < aenderungen.length; i++) {
      var neu = aenderungen[i].addedNodes;
      for (var j = 0; j < neu.length; j++) {
        if (bringtSterne(neu[j])) {
          clearTimeout(warte);
          warte = setTimeout(einrichten, 300);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
